/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import LiveroomCell from './LiveroomCell'
import Config from '../../config'
import MainPageRight from '../../images/liveroomSetting/liveroom-setting-right.png'

class MainTopBar extends React.Component {

    renderCellBody (){
        const {liveroomInfo} = this.props.liveroomSetting;
        return (
            <div className="main-page-top-left">
                <Link to={`/liveroom/${liveroomInfo.liveroom.id}/edit/profile`}>
                    <div className="main-page-top-canclick"></div>
                </Link>
                {/*<div className="main-page-top-right">
                    <img src={MainPageRight} alt=""/>
                </div>*/}
                <div className="top-left-icon">
                    <div className="liveroom-slidetop-content-main-type">
                        {
                            liveroomInfo.liveroom.verify_type === 2 &&
                            <i className="iconfont verify-type-icon icon-yfv">
                            </i>
                        }
                        {
                            liveroomInfo.liveroom.verify_type === 1 &&
                            <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv">
                            </i>
                        }
                    </div>
                    <div className="top-left-icon-img">
                        <Link to={`/liveroom/${liveroomInfo.liveroom.id}/edit/profile`}>
                            <img src={liveroomInfo.liveroom.avatar_url} alt=""/>
                        </Link>
                    </div>
                </div>
                <div className="top-left-text">
                    <Link to={`/liveroom/${liveroomInfo.liveroom.id}/edit/profile`}>
                        <p className="title">{liveroomInfo.liveroom.name}</p>
                    </Link>
                    {liveroomInfo.liveroom.verify_type === 0 &&
                    <p className="renzheng"><Link to={`/liveroom/${liveroomInfo.liveroom.id}/verify`}>点击认证直播间</Link></p>
                    }
                    {liveroomInfo.liveroom.verify_type === 1 &&
                    <p className="renzheng"><Link to={`/liveroom/${liveroomInfo.liveroom.id}/verify`}>个人认证</Link></p>
                    }
                    {liveroomInfo.liveroom.verify_type === 2 &&
                    <p className="renzheng"><Link to={`/liveroom/${liveroomInfo.liveroom.id}/verify`}>机构认证</Link></p>
                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="main-top-bar">
                <LiveroomCell body={this.renderCellBody()} />
            </div>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(MainTopBar)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainTopBar.js